import React from "react";
import ATable from "../../common/table";

const MerchantDisputantsTable = (props) => {
  const columns = [
    {
      width: 50,
      header: "S/N",
      render: (row) => (
        <div>
          {props.table === "searchTable"
            ? row.viewIndex + 1
            : props.paginatedCallBack(row.viewIndex)}
        </div>
      ),
    },
    {
      header: "Domain Code",
      accessor: "domainCode",
    },
    {
      header: "Domain Name",
      accessor: "domainName",
    },
    {
      header: "Email Address",
      accessor: "email",
    },
    {
      width: 100,
      header: "Status",
      render: (row) => <div>{row.row.mapped && "Mapped"}</div>,
    },
  ];
  return (
    <ATable
      manual
      columns={columns}
      className="-striped -highlight"
      tableData={props.merchantDisputants}
      onChange={props.onTableChange || null}
      {...props}
    />
  );
};

export default MerchantDisputantsTable;



// WEBPACK FOOTER //
// ./src/components/admin/merchantDisputants/merchantDisputantsTable.js